import React from "react";
import "./Loader.css"; // Style file for loader

const Loader = () => {
  return (
    <div className="loader">
      <span className="loading-text">Coeus</span>
    </div>
  );
};

export default Loader;
